import React, { PropsWithChildren } from 'react';
import { CristalContext, ICristalContext } from '../../../contexts/cristal';
import {
  isQuestionnaireResponseItemAnswer,
  isIntegerAnswerComponent,
} from '../../../modules/unsw-fhir/QuestionnaireResponse/typeGuards';
import { getQuestionnaireByName } from '../../../apis/questionnaire';
import { getQuestionnaireResponseByReference } from '../../../apis/questionnaireResponse';
import produce from 'immer';

type CristalProviderProps = PropsWithChildren<{ patientId?: string }>;

class CristalProvider extends React.PureComponent<
  CristalProviderProps,
  ICristalContext
> {
  constructor(props: CristalProviderProps) {
    super(props);
    this.state = {
      score: 0,
      setScore: this.setScore,
    };
  }

  componentDidMount = async () => {
    await this.updateScore();
  };

  componentDidUpdate = async (prevProps: CristalProviderProps) => {
    if (prevProps.patientId !== this.props.patientId) {
      await this.updateScore();
    }
  };

  render = () => {
    return (
      <CristalContext.Provider value={this.state}>
        {this.props.children}
      </CristalContext.Provider>
    );
  };

  private setScore = (score: number) =>
    this.setState(state =>
      produce(state, draft => {
        draft.score = score;
      }),
    );

  private updateScore = async () => {
    try {
      this.setState(state =>
        produce(state, draft => {
          draft.loading = true;
        }),
      );
      const questionnaire = await getQuestionnaireByName('cristal');

      if (!questionnaire) return;

      if (!this.props.patientId || !questionnaire.id) return;
      const questionnaireResponse = await getQuestionnaireResponseByReference(
        this.props.patientId,
        questionnaire.id,
      );
      if (questionnaireResponse) {
        const item = questionnaireResponse.item.find(i => i.linkId === '8-0');

        if (item && isQuestionnaireResponseItemAnswer(item)) {
          const answer = item.answer[0];
          const score =
            answer && isIntegerAnswerComponent(answer)
              ? answer.valueInteger
              : 0;
          this.setState(state =>
            produce(state, draft => {
              draft.score = score;
            }),
          );
        }
      }
    } catch (e) {
      this.setState(state =>
        produce(state, draft => {
          draft.error = e as string | undefined;
        }),
      );
    } finally {
      this.setState(state =>
        produce(state, draft => {
          draft.loading = false;
        }),
      );
    }
  };
}

export default CristalProvider;
